import { formatDate } from '@angular/common';
import * as moment from 'moment';

export class DateHelper {
  static FORMAT_DATE: string = 'yyyy-MM-dd';
  static FORMAT_DATE_YYYY_MM_DD: string = 'YYYY-MM-DD';
  static FORMAT_DATE_HMS: string = 'yyyy-MM-dd HH:mm:ss';
  static DS_CALENDAR_FORMAT_DATE: string = 'yy-mm-dd';

  static formatDate(value: string | number | Date, format?: string): string {
    return formatDate(value, format || 'yyyy-MM-ddTHH:mm:ss', 'en-US');
  }

  static normalizeDateYYYYMMDD(value: string): string {
    const dataFormatted = value?.trim().split(/[.-]/g);
    if (dataFormatted && dataFormatted.length === 3) {
      return dataFormatted[0].length === 4
        ? dataFormatted.join('-')
        : dataFormatted.reverse().join('-');
    }
    return null;
  }

  static addToDate(date: string, years: number, months: number, days: number) {
    const d = new Date(date);
    d.setFullYear(d.getFullYear() + years);
    d.setMonth(d.getMonth() + months);
    d.setDate(d.getDate() + days);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  static dateDiffInDays(a, b) {
    const msPerDay = 1000 * 60 * 60 * 24;
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / msPerDay);
  }

  static getDate(date: string): Date {
    return date ? moment(date, DateHelper.FORMAT_DATE_YYYY_MM_DD).toDate() : moment(new Date(), DateHelper.FORMAT_DATE_YYYY_MM_DD).toDate();
  }
}
